// A'gong Social — scroll animations + slider with per-slide video & profile bar
document.addEventListener('DOMContentLoaded', function () {

  var platformIcons = {
  instagram: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><rect x="2" y="2" width="20" height="20" rx="5" stroke="white" stroke-width="2" fill="none"/><circle cx="12" cy="12" r="5" stroke="white" stroke-width="2" fill="none"/><circle cx="17.5" cy="6.5" r="1.5" fill="white"/></svg>',
  tiktok:    '<svg width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.75a8.17 8.17 0 004.78 1.53V6.79a4.85 4.85 0 01-1.01-.1z"/></svg>',
  youtube:   '<svg width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M23 7s-.3-1.9-1.1-2.7c-1.1-1.1-2.3-1.1-2.8-1.2C16.3 3 12 3 12 3s-4.3 0-7.1.1c-.6.1-1.8.1-2.8 1.2C1.3 5.1 1 7 1 7S.7 9.1.7 11.3v2c0 2.1.3 4.2.3 4.2s.3 1.9 1.1 2.7c1.1 1.1 2.5 1.1 3.1 1.1C7.1 21.5 12 21.5 12 21.5s4.3 0 7.1-.2c.6-.1 1.8-.1 2.8-1.2.8-.8 1.1-2.7 1.1-2.7s.3-2.1.3-4.2v-2C23.3 9.1 23 7 23 7zM9.7 15.5V8.4l7.6 3.6-7.6 3.5z"/></svg>',
  facebook:  '<svg width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M24 12.07C24 5.41 18.63 0 12 0S0 5.41 0 12.07C0 18.1 4.39 23.1 10.13 24v-8.44H7.08v-3.49h3.04V9.41c0-3.02 1.8-4.7 4.54-4.7 1.31 0 2.68.24 2.68.24v2.97h-1.51c-1.49 0-1.95.93-1.95 1.88v2.26h3.32l-.53 3.49h-2.79V24C19.61 23.1 24 18.1 24 12.07z"/></svg>',
  twitter:   '<svg width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.748l7.73-8.835L1.254 2.25H8.08l4.264 5.634 5.9-5.634zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>'
};

  if (!document.querySelector('[data-agong-social]')) return;

  // ── Scroll-in animations ──
  if (window.IntersectionObserver) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('[data-agong-social-anim]').forEach(function (el) {
      io.observe(el);
    });
  } else {
    document.querySelectorAll('[data-agong-social-anim]').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  // ── Slider ──
  document.querySelectorAll('[data-agong-slider]').forEach(function (slider) {
    var track      = slider.querySelector('[data-agong-slider-track]');
    var prevBtn    = slider.querySelector('[data-agong-slider-prev]');
    var nextBtn    = slider.querySelector('[data-agong-slider-next]');
    if (!track) return;

    var slides     = Array.prototype.slice.call(track.querySelectorAll('[data-agong-slide]'));
    var total      = slides.length;
    var current    = 0;
    var soundOn    = false;

    // Only the first slide's video should actually be playing on load —
    // pause the rest (they still have the autoplay attribute so they're
    // ready to go instantly once swiped into view) and sync the button icon.
    slides.forEach(function (s, i) {
      var v = s.querySelector('video');
      if (!v) return;
      var b = s.querySelector('[data-agong-play]');
      if (i === 0) {
        if (b) b.classList.add('is-playing');
      } else {
        v.pause();
      }

      var muteBtn = s.querySelector('[data-agong-mute]');
      if (muteBtn) {
        muteBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          soundOn = !soundOn;
          v.muted = !soundOn;
          muteBtn.classList.toggle('is-muted', !soundOn);
        });
      }
    });

    if (total < 2) return;

    // Elements outside the slider that update per slide
    var section    = slider.closest('[data-agong-social]');
    var dotsWrap   = section.querySelector('[data-agong-dots]');
    var dots       = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('.agong-social__dot')) : [];
    var pageLabel  = section.querySelector('[data-agong-pagination-label]');
    var platformEl = section.querySelector('[data-agong-slide-platform]');
    var handleEl   = section.querySelector('[data-agong-slide-handle]');
    var linkEl     = section.querySelector('[data-agong-slide-link]');
    var iconEl     = section.querySelector('[data-agong-slide-icon]');

    // Parse per-slide data from JSON tag
    var dataTag    = section.querySelector('[data-agong-slide-data]');
    var slideData  = [];
    try { slideData = JSON.parse(dataTag ? dataTag.textContent : '[]'); } catch (e) {}

    function goTo(index) {
      // Pause any playing video on current slide
      var curVideo = slides[current].querySelector('video');
      if (curVideo && !curVideo.paused) curVideo.pause();
      var curBtn = slides[current].querySelector('[data-agong-play]');
      if (curBtn) curBtn.classList.remove('is-playing');

      current = ((index % total) + total) % total;

      // Slide track
      track.style.transform = 'translateX(-' + (current * 100) + '%)';

      // Dots
      dots.forEach(function (d, i) {
        d.classList.toggle('agong-social__dot--active', i === current);
      });

      // Pagination label
      if (pageLabel) pageLabel.textContent = (current + 1) + ' / ' + total;

      // Profile bar — fade out, update, fade in
      var data = slideData[current] || {};
      if (platformEl) fadeUpdate(platformEl, data.platform || '');
      if (handleEl)   fadeUpdate(handleEl, data.handle || '');
      if (linkEl && data.link) linkEl.setAttribute('href', data.link);

      // Icon colour class
      if (iconEl) {
  var iconType = (data.icon_type || 'instagram').toLowerCase();
  iconEl.innerHTML = platformIcons[iconType] || platformIcons['instagram'];

  // Update background color
  iconEl.classList.remove('is-tiktok', 'is-youtube', 'is-facebook', 'is-twitter');
  if (iconType === 'tiktok')   iconEl.classList.add('is-tiktok');
  if (iconType === 'youtube')  iconEl.classList.add('is-youtube');
  if (iconType === 'facebook') iconEl.classList.add('is-facebook');
  if (iconType === 'twitter')  iconEl.classList.add('is-twitter');
}

      // Autoplay the newly active slide's video
      var newVideo = slides[current].querySelector('video');
      if (newVideo) {
        newVideo.muted = !soundOn;
        var playPromise = newVideo.play();
        if (playPromise && playPromise.catch) playPromise.catch(function () {});
        var newBtn = slides[current].querySelector('[data-agong-play]');
        if (newBtn) newBtn.classList.add('is-playing');
        var newMuteBtn = slides[current].querySelector('[data-agong-mute]');
        if (newMuteBtn) newMuteBtn.classList.toggle('is-muted', !soundOn);
      }
    }

    function fadeUpdate(el, text) {
      el.style.opacity = '0';
      setTimeout(function () {
        el.textContent = text;
        el.style.opacity = '1';
      }, 200);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    // Dots click
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });

    // Touch / swipe support
    var touchStartX = 0;
    track.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
    });
  });

  // ── Play / pause buttons for uploaded videos ──
  document.querySelectorAll('[data-agong-play]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var video = btn.closest('.agong-social__live-player').querySelector('video');
      if (!video) return;
      if (video.paused) {
        video.play();
        btn.classList.add('is-playing');
      } else {
        video.pause();
        btn.classList.remove('is-playing');
      }
    });
  });
});